import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import ScreensRoot from './screens/Root';


function App() {
    return (
        <BrowserRouter>
            <ScreensRoot />
        </BrowserRouter>
    );
}


export default App;
